import {
    DatePicker,
    DatePickerProps,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import { Field, useFormikContext } from "formik";
import { DateTime } from "luxon";
import React from "react";
import { useFieldValueAndValidation } from "ui/componentes/Form/functions";

type ModifiedDatePickerProps = Omit<DatePickerProps, "value" | "onChange">;

interface DateFieldFormikProps {
    fieldType?: "datePicker" | "keyboardDatePicker";
}

const DateFieldFormik: React.FC<
    ModifiedDatePickerProps & DateFieldFormikProps
> = ({ fieldType = "datePicker", ...props }) => {
    const { setFieldValue, setFieldTouched } = useFormikContext<any>();

    const datePickerComponent =
        fieldType === "datePicker" ? DatePicker : KeyboardDatePicker;

    let dateValue: any = null;

    const { value, error, hasTouched } = useFieldValueAndValidation(props.name);
    const showError = !!error && hasTouched;
    if (value) {
        dateValue = DateTime.fromFormat(value, "yyyy-MM-dd");
    }

    return (
        <Field
            autoOk
            format="dd/MM/yyyy"
            {...props}
            onBlur={() => setFieldTouched(props.name || "", true)}
            value={dateValue}
            onChange={(v: DateTime) => {
                setFieldTouched(props.name || "", true);
                setFieldValue(
                    props.name || "",
                    v ? v.toFormat("yyyy-MM-dd") : null
                );
            }}
            component={datePickerComponent}
            error={showError}
            helperText={showError ? error : props.helperText}
        />
    );
};

export { DateFieldFormik };
